import {Form} from "react-bootstrap";
import React from "react";

const AddressForm = ({nome, cognome, indirizzo, citta, nazione, codicePostale, recapito, setNome, setCognome, setIndirizzo, setCoicePostale, setCitta, setNazione, setRecapito, editMode}) =>{

        return (
            <Form>

                <Form.Group className="mb-4">
                    <Form.Label>Nome*</Form.Label>
                    <Form.Control type='text' placeholder="nome" value={nome} disabled={editMode} onChange={(e) => setNome(e.target.value)}/>
                </Form.Group>

                <Form.Group className="mb-4">
                    <Form.Label>Cognome*</Form.Label>
                    <Form.Control type='text' placeholder="cognome" value={cognome} disabled={editMode} onChange={(e) =>setCognome(e.target.value)} />
                </Form.Group>

                <Form.Group className="mb-4">
                    <Form.Label>Indirizzo*</Form.Label>
                    <Form.Control type='text' placeholder="indirizzo" value={indirizzo} onChange={(e) => setIndirizzo(e.target.value)}/>
                </Form.Group>

                <Form.Group className="mb-4">
                    <Form.Label>Codice postale*</Form.Label>
                    <Form.Control type='text' placeholder="codice postale" value={codicePostale} onChange={(e) => setCoicePostale(e.target.value)}/>
                </Form.Group>

                <Form.Group className="mb-4">
                    <Form.Label>Città*</Form.Label>
                    <Form.Control type='text' placeholder="città" value={citta} onChange={(e) => setCitta(e.target.value)}/>
                </Form.Group>

                <Form.Group className="mb-4">
                    <Form.Label>Nazione*</Form.Label>
                    <Form.Select value={nazione} onChange={(e) => setNazione(e.target.value)}>
                        <option value="">seleziona nazione</option>
                        <option value="CH">CH</option>
                        <option value="IT">IT</option>
                    </Form.Select>
                </Form.Group>

                <Form.Group className="mb-4">
                    <Form.Label>Recapito telefonico*</Form.Label>
                    <Form.Control type='tel' placeholder="telefono" value={recapito} onChange={(e) => setRecapito(e.target.value)}/>
                </Form.Group>

                <p>* campi obbligatori</p>

            </Form>
        );
}
export default AddressForm;
